import React, { useState, useEffect } from 'react';
import useStyles from './useStyles';
import {Grid, Typography, Card, CircularProgress} from '@mui/material'
//import InputForm from '../../components/Forms/InputForm';
import useRegistration from './useRegistration';
//import InputDateForm from '../../components/Forms/InputDateForm';
//import InputSelectForm from '../../components/Forms/InputSelectForm';
//import ActionModalBar from '../../components/Actions/ActionModalBar';
import SuccessModal from './modals/SuccessModal';
//import { CONFIG_SETTINGS } from '../../config';
//import ReCAPTCHA from 'react-google-recaptcha';
import SuccessView from './views/SuccessView';
//import CameraContainer from './components/CameraContainer';
import PersonalDataForm from './views/PersonalDataForm';
//import RegistrationHeader from './components/RegistrationHeader';
import CustomStepper from './components/CustomStepper';
import PhoneNumberRequest from './views/PhoneNumberRequest';
import SMSValidation from './views/SMSValidation';
import TermsConditionForm from './views/TermsConditionForm';
//import useAuth from '../../hooks/useAuth';
import UUIDErrorModal from './modals/UUIDErrorModal';
import { REGISTRATION_STEPS } from '../../utils/enums';
import CasinoPinValidation from './views/CasinoPinValidation';

/**
 * @module Layouts/Registration/RegistrationLayout
 * @description The `RegistrationLayout` function is a React component that renders different views based on the
 * current step of a registration process
 * @returns {React.ReactElement} The `RegistrationLayout` component is being returned as a View.
 */

/**
 * 
 * @typedef RegistrationLayout
 * @property {MUIStyles} classes - The styles for the component 
 * @property {Object} system - Component system variables
 * @property {Boolean} system.loading - Loading status
 * @property {Boolean} system.sending - Sending status
 * @property {String} system.error - Error status
 * @property {Object} data - General data variables
 * @property {String} data.captcha - Captcha value for Google Recaptcha response
 * @property {Array<Object>} data.steps - Array that contains a value and a description for each view Step
 * @property {Number} data.phoneCode - Code obtained from SMS
 * @property {Number} data.agreementCollections - Array of Flexia Agreement Terms
 * @property {Number} data.issuer_statement - Contrains of the registrations process
 * @property {Number} data.smartyAddresses - Response of smarty API service, could contain an address or an object with error reasons
 * @property {Boolean} data.valid_captcha - Status if the client's has a valid recaptcha
 * @property {File | Blob} data.document - Document File get from agreementCollenctions item 



 * @returns {React.ReactElement} The `RegistrationLayout` component is being returned as a View.
 */

const RegistrationLayout = () => {

    const classes = useStyles()


    const {system, data, actions, form, modals, authManager} = useRegistration()
    const [message, setMessage] = useState('No result');


    let contentView = null

    if(data.view === REGISTRATION_STEPS.PHONENUMBER_REQUEST) contentView = <PhoneNumberRequest system={system} data={data} actions={actions} form={form}/>
    if(data.view === REGISTRATION_STEPS.SMS_REQUEST) contentView = <SMSValidation system={system} data={data} actions={actions} form={form}/>
    if(data.view === REGISTRATION_STEPS.CASINO_PIN) contentView = <CasinoPinValidation system={system} data={data} actions={actions} form={form}/>
    if(data.view === REGISTRATION_STEPS.TERMS_CONDITION) contentView = <TermsConditionForm system={system} data={data} actions={actions} form={form} modals={modals}/>
//
    if(data.view === REGISTRATION_STEPS.USER_FORM) contentView = <PersonalDataForm system={system} data={data} actions={actions} form={form} modals={modals}/>
//
    if(data.view === REGISTRATION_STEPS.SUCCESS) contentView = <SuccessView />

    let title = data.view !== REGISTRATION_STEPS.SUCCESS ? 'Registration' : 'Cardholder Registration'


    
    return ( 
        <div className={classes.root} >
            <div className={classes.subroot}>
                <UUIDErrorModal open={modals.uuid_error}/>
                <SuccessModal 
                    open={modals.success} 
                    onResetForm={actions.onResetForm}
                    onClose={() => actions.onUpdateModalStatus('success', false)} />
                
                <div className={classes.container}>
                   
                    <Typography variant='h3' className={classes.title} align='center'>
                        {title}
                    </Typography>
                    <div style={{paddingTop:8}}>
                        <CustomStepper steps={data.steps} activeStep={data.view}/>
                    </div>
                    <Card className={classes.card}>
                        {system.loading ? (
                            <div>
                                <Grid container justifyContent='center' alignItems='center' direction='column'>
                                    <Grid item>
                                        <CircularProgress size={48}/>
                                    </Grid>
                                    <Grid item>
                                        <Typography>Loading...</Typography>
                                    </Grid>
                                </Grid>
                            </div>
                        ) : null}
                        {contentView}
                    </Card>
                    <div>
                        <Typography align='center' className={classes.version}>Version {window.MASTER_VERSION}</Typography>
                    </div>
                    
                </div>
                
            </div>
            
        </div>
     );
}

export default RegistrationLayout;